import React from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import {InsigniaCustomization} from '../../i';
import {InsigniaList} from './components/insignia-list';
import * as emitter from '../../../global/emitter';
import {capitalize} from '../../../util';

export const getTitle = (title = s.ui.title_insignia, color = s.pcs.insignia_dyf_color) => {
    const hasColorInTitle = title?.toLowerCase().includes(color?.toLowerCase());

    if (s.pcs.is_caf || !color || hasColorInTitle) {
        return title;
    } else {
        return `${title} ${capitalize(color)}`;
    }
};

@observer
export default class Insignia extends React.Component {
    @observable init_ins: boolean = false;
    @observable orig_ins_name: string = '';
    @observable collapsed: boolean = true;
    @observable collapsed_number: number = 4;
    @observable fpc_id: number = -1;
    @observable show_insignia_dropdown: boolean = true;

    constructor(props) {
        super(props);
        this.initInsignia = this.initInsignia.bind(this);
        this.orig = this.orig.bind(this);
        this.save = this.save.bind(this);
        this.collapseToggle = this.collapseToggle.bind(this);
        this.changeCategory = this.changeCategory.bind(this);
        this.ins_remove = this.ins_remove.bind(this);
        this.LinoChanged = this.LinoChanged.bind(this);
        if (s.pcs.is_caf) {
            this.fpc_id = -2;
        }
        makeObservable(this);
    }

    componentDidMount() {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'lino_changed', this.LinoChanged);
    }

    @action
    LinoChanged = async () => {
        if (!s.prod.insignias || s.prod.insignias.length < 1 || s.prod.IsCAF) {
            return;
        } else if (s.prod.insignias.length === 1) {
            await this.orig();
            return;
        }

        if (s.prod.IsCAF) {
            return;
        }

        const m = s.prod.insignias
            .filter(m => m.gradSchoolId === s.currentGradSchoolID)
            .filter(m => (s.pcs.ins_gold_allowed && m.ins_color === 'gold') || (s.pcs.ins_silver_allowed && m.ins_color === 'silver') || (s.pcs.ins_black_allowed && m.ins_color === 'black') || (m.ins_color !== 'black' && m.ins_color !== 'silver' && m.ins_color !== 'gold'));
        if (m && m.length > 0) {
            await this.save(m[0].id);
            return;
        } else {
            await this.orig();
            return;
        }
    };

    @action
    initInsignia = async () => {
        this.orig_ins_name = JSON.parse(JSON.stringify(s.prod.orig_pcs.Base_InsigniaName));
        this.init_ins = true;

        if (s.prod.IsCAF) {
            this.show_insignia_dropdown = true;
        } else if (s.prod.InsigniaID < 1 && s.prod.insignias.length > 0) {
            this.show_insignia_dropdown = false;
        } else if (s.prod.ProductTypeID === 83 || s.prod.ProductTypeID === 84 || s.prod.ProductTypeID === 87) {
            this.show_insignia_dropdown = false;
        }

        if (!s.prod.IsCAF) {
            this.show_insignia_dropdown = false;
        }

        if (s.prod.InsigniaID > 0) {
            this.orig();
        }
    };

    @action
    orig = async () => {
        s.pcs.insignia_id = s.prod.InsigniaID;
        s.pcs.insignia_base_name = this.orig_ins_name;
        s.pcs.insignia_dyf_color = 'gold';
        s.pcs.insignia_is_dyf = false;
        s.ui.update_pricing = true;
        s.ui.doRender = true;

        const m = s.prod.insignias.filter(m => m.id === s.prod.InsigniaID)[0];
        s.pcs.insignia_id = m.id;
        s.pcs.insignia_base_name = m.name;
        s.pcs.insignia_is_dyf = m.isCAF;
        s.pcs.insignia_dyf_color = m.ins_color.toLowerCase();
        s.ui.name_insignia = m.name.toLowerCase();
        s.ui.title_insignia = m.title;
        s.ui.doRender = true;
        s.ui.update_pricing = true;

        s.pulse();

        if (window.innerWidth < 1200) {
            const d = document.getElementById('frame-display') as HTMLDivElement;
            d.scrollIntoView();
        }
    };

    @action
    save = async (d_i: number) => {
        const m = s.prod.insignias.filter(m => m.id === d_i)[0];
        if (m.id === s.prod.InsigniaID) {
            this.orig();
            return;
        }
        s.pcs.insignia_id = m.id;
        console.log('ins', s.pcs.insignia_id);
        s.pcs.insignia_base_name = m.name;
        s.pcs.insignia_is_dyf = m.isCAF;
        s.pcs.insignia_dyf_color = m.ins_color.toLowerCase();
        s.ui.name_insignia = m.name.toLowerCase();
        s.ui.title_insignia = m.title;
        s.ui.doRender = true;
        s.ui.update_pricing = true;
        s.pulse();

        if (window.innerWidth < 1200) {
            const d = document.getElementById('prod-header') as HTMLDivElement;
            d.scrollIntoView();
        }
    };

    @action
    collapseToggle = async () => {
        this.collapsed = !this.collapsed;
        this.collapsed_number = this.collapsed ? 4 : 1000;
    };

    @action
    changeCategory = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.fpc_id = parseInt(e.target.value);
    };

    @action
    ins_remove = async (e: any) => {
        s.pcs.insignia_id = -1;
        s.ui.title_insignia = '';
        s.ui.update_pricing = true;
        s.ui.doRender = true;
        s.pulse();
    };

    @computed get canCollapse(): boolean {
        return s.pcs.is_caf || window.innerWidth < 960;
    }

    render() {
        if (!s || !s.ui.show_cust || !s.prod || !s.prod.insignias || (s.prod.insignias.length <= 1 && !(s.prod.InsigniaID < 1 && s.prod.insignias.length > 0))) {
            return;
        }
        if (!this.init_ins) {
            this.initInsignia();
        }

        const insigniaFilteredList = () =>
            s.prod.insignias.filter(
                m => (!s.prod.IsCAF ? m.gradSchoolId === s.currentGradSchoolID : m.fpc_id === this.fpc_id || this.fpc_id === -2) && ((s.pcs.ins_gold_allowed && m.ins_color === 'gold') || (s.pcs.ins_silver_allowed && m.ins_color === 'silver') || (s.pcs.ins_black_allowed && m.ins_color === 'black')),
            );

        return (
            <div
                className="gray-box ins-container"
                style={{padding: 0}}
            >
                <div className={this.canCollapse ? '' : ''}>
                    <div style={{padding: '0 12px'}}>
                        <div
                            role={this.canCollapse ? 'button' : undefined}
                            tabIndex={this.canCollapse ? 0 : undefined}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.currentTarget.click();
                                }
                            }}
                            className="d-none d-xl-block toggle-bs"
                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                            data-bs-target="#insignia-inner"
                            aria-expanded={this.canCollapse ? false : undefined}
                            aria-controls={this.canCollapse ? 'insignia-inner' : undefined}
                        >
                            <div className="cust-desktop-head">
                                <span>Insignia: </span>
                                <span>{getTitle()}</span>
                            </div>
                        </div>

                        <div
                            role="button"
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.currentTarget.click();
                                }
                            }}
                            className="d-block d-xl-none toggle-bs"
                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                            data-bs-target="#insignia-inner"
                            aria-expanded={this.canCollapse ? false : undefined}
                            aria-controls={this.canCollapse ? 'insignia-inner' : undefined}
                        >
                            <div className="cust-flex-head">
                                <div>
                                    <div
                                        className="header-std flexer cust-flex2"
                                        style={{paddingRight: '0.25rem'}}
                                    >
                                        Insignia
                                    </div>
                                    <div className="cust-flex2">{getTitle()}</div>
                                </div>
                                <div>
                                    {this.canCollapse &&
                                        this.collapsed &&
                                        s.prod.insignias
                                            .filter(m => m.id === s.pcs.insignia_id)
                                            .map((m: InsigniaCustomization, i: number) => (
                                                <img
                                                    key={i}
                                                    src={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${m.name.toLowerCase()}_90.png`}
                                                    alt={m.title}
                                                    style={{
                                                        backgroundColor: `#${s.ui.color_mat1}`,
                                                        height: 48,
                                                        width: 'auto',
                                                    }}
                                                />
                                            ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        id="insignia-inner"
                        className={this.canCollapse ? 'collapse' : ''}
                        style={{padding: '0 12px'}}
                    >
                        {s.prod.ProductID !== 75593 && s.prod.ProductID !== 75595 && s.prod.ProductID !== 75591 && s.prod.ProductID !== 75589 && this.show_insignia_dropdown && (
                            <div
                                className="form-floating"
                                style={{width: 250}}
                            >
                                <select
                                    className="form-select"
                                    style={{
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        height: '100%',
                                        marginBottom: 10,
                                    }}
                                    aria-label="Select Insignia"
                                    onChange={this.changeCategory}
                                >
                                    {s.prod.insignias.filter(m => !m.isCAF).length > 0 && s.prod.insignias.length > 3 && <option value={-1}>Original</option>}
                                    {s.prod.insignias.filter(m => m.isCAF).length > 0 && <option value={-2}>All</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 21).length > 0 && <option value={21}>Academic</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 22).length > 0 && <option value={22}>Honors</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 23).length > 0 && <option value={23}>Degrees</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 24).length > 0 && <option value={24}>Military</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 25).length > 0 && <option value={25}>Profession</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 26).length > 0 && <option value={26}>Sports</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 27).length > 0 && <option value={27}>Mascots</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 29).length > 0 && <option value={29}>Interests</option>}
                                    {s.prod.insignias.filter(m => m.fpc_id === 40).length > 0 && <option value={40}>State Seals</option>}
                                </select>
                            </div>
                        )}

                        <InsigniaList
                            fpcId={this.fpc_id}
                            collapsed={this.collapsed}
                            collapsedNumber={this.collapsed_number}
                            save={this.save}
                        />

                        {insigniaFilteredList().length > 4 && (
                            <button
                                className="btn btn-outline-secondary btn-sm btn-toggle"
                                onClick={this.collapseToggle}
                                style={{margin: '4px 0 2px 0', color: '#000000', display: 'flex', justifySelf: 'center'}}
                                aria-label={this.collapsed ? `+ View all ${s.prod.insignias.filter(m => m.fpc_id === this.fpc_id).length} insignia` : '- View less insignia'}
                            >
                                {this.collapsed ? `+ View ${insigniaFilteredList().length - 4} more insignia` : '- View less insignia'}
                            </button>
                        )}

                        {((s.pcs.is_caf && s.pcs.insignia_id > 0) || (!s.pcs.is_caf && s.prod.InsigniaID < 1 && s.pcs.insignia_id > 0)) && (
                            <div
                                className="ep-toggle text-center"
                                style={{marginBottom: '1rem'}}
                            >
                                <hr style={{margin: '0.5rem 0'}} />
                                <button
                                    type="button"
                                    aria-label="Remove insignia from product"
                                    className="btn btn-secondary"
                                    onClick={this.ins_remove}
                                >
                                    Remove Insignia
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
